module.exports = __webpack_public_path__ + "img/Integrity-2021.697de8e4.png";